import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import ViewFeatured from '../components/ViewFeatured';
import { getFeaturedMatches } from '../actions/feature';

type AppDispatch = ThunkDispatch<RootReducerState, unknown, FeatureAction>;

interface MapStateToProps {
  content?: RootStockData
}

const mapStateToProps = (state: RootReducerState): MapStateToProps => {
  return {
    content: state.featured.content
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getFeaturedMatches: (date?: string, unlock?: string) => dispatch(getFeaturedMatches(date, unlock))
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type ViewFeaturedProps = ConnectedProps<typeof connector>;
export default connector(ViewFeatured);
